module.exports = __webpack_public_path__ + "img/base.a107a509.png";